import { EN_REQUEST_ERRORS } from '@/services/RequestService/IRequester';
import { Either } from 'tsmonad';

import { noTransform } from './noTransform';
import { ResponseTransformer } from './ResponseTransformer';
import { responseError } from '..';

/** 204 응답을 오류로 변환한다. */
export const noContentAs404: ResponseTransformer = response =>
  noTransform(response).chain(resp =>
    resp.statusCode === 204 ? responseError(404, EN_REQUEST_ERRORS.CLIENT) : Either.right(resp),
  );
